import script from "./CompanyListView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyListView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyListView.vue?vue&type=style&index=0&id=f8d84e18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8d84e18"]])

export default __exports__